var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prd-multiselect',{attrs:{"options":_vm.options,"value":_vm.current,"reset-after":false,"close-on-select":true,"label":"serialNumber","is-valid":_vm.isValid},on:{"select":_vm.serialNumberSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }